import React from 'react';

import {Backdrop, Modal as MuiModal, Fade, IconButton, ModalProps} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import tw, { styled } from 'twin.macro';

export type Props = ModalProps & {
  noCloseButton?: boolean;
  fadeTimeout?: number;
};

const StyledBackdrop = styled(Backdrop)`
  background-color: rgba(65, 65, 80, 0.47);
`;

const ContentContainer = styled.div`
  /* Don't use tailwind to make these default values easy to overwrite */
  background-color: white;
  padding: 1rem;
  ${tw`relative rounded`}
`;

export function Modal({ fadeTimeout, open, onClose, noCloseButton, children, style, className, ...props }: Props) {

  return (
    <MuiModal
      className="flex items-center justify-center"
      open={open}
      onClose={onClose}
      BackdropComponent={StyledBackdrop}
      closeAfterTransition
      {...props}
    >
      <Fade in={open} unmountOnExit timeout={fadeTimeout === undefined ? 750 : fadeTimeout}>
        <ContentContainer className={className} style={style}>
          {!noCloseButton && (
            <IconButton onClick={() => onClose && onClose({}, 'backdropClick')} aria-label="Cancel" className="absolute top-0 right-0 m-3">
              <CloseIcon className="text-2xl text-blue-900 fill-current" />
            </IconButton>
          )}
          {children}
        </ContentContainer>
      </Fade>
    </MuiModal>
  );
}
